import { SVGProps } from "react";

const MinusIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
        <g clipPath="url(#a)">
            <path
                fill="currentColor"
                d="M4.92 13.053c-.566 0-1.084-.498-1.084-1.094 0-.596.518-1.084 1.084-1.084h14.16c.586 0 1.084.488 1.084 1.084 0 .596-.498 1.094-1.084 1.094H4.92Z"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
        </defs>
    </svg>
);
export default MinusIcon;
